const lookup = [
    { value: 1000, symbol: 'M' },
    { value: 900,  symbol: 'CM' },
    { value: 500,  symbol: 'D' },
    { value: 400,  symbol: 'CD' },
    { value: 100,  symbol: 'C' },
    { value: 90,   symbol: 'XC' },
    { value: 50,   symbol: 'L' },
    { value: 40,   symbol: 'XL' },
    { value: 10,   symbol: 'X' },
    { value: 9,    symbol: 'IX' },
    { value: 5,    symbol: 'V' },
    { value: 4,    symbol: 'IV' },
    { value: 1,    symbol: 'I' },
];

export const intToRoman = (num) => {
    if (typeof num !== 'number' || num % 1 !== 0) {
      return '0';
    }
    if (num < 1 || num > 3999) { // might be 0 with some of the numbers from DBQ jsons
      return '0';
    }
  
    let result = '';
    for (const { value, symbol } of lookup) {
      while (num >= value) {
        result += symbol;
        num -= value;
      }
    }

    return result;
}